export const MAP_SETTINGS_DISTANCE_CALCULATOR_SUBMIT_DC_INSTANCE = 'MAP_SETTINGS_DISTANCE_CALCULATOR_SUBMIT_DC_INSTANCE';
export const MAP_SETTINGS_DISTANCE_CALCULATOR_DELETE_DC_INSTANCE = 'MAP_SETTINGS_DISTANCE_CALCULATOR_DELETE_DC_INSTANCE';

export const MAP_SETTINGS_DISTANCE_CALCULATOR_OUTLINE_MOVE = 'MAP_SETTINGS_DISTANCE_CALCULATOR_OUTLINE_MOVE';
